import { fromPromise } from 'xstate';
import { ServiceShortName } from '@acp/shared';
import {
    requestQuoteReportedFindings,
    getPropertyReportedFindingsWizard,
    dismissReportedFinding,
    unDismissReportedFinding,
    informDIRequest,
    submitReportedFindingsDetails,
    resolveBuildYearRequest,
} from '../../../service';

export const reportedFindingsWizardActors = {
    getReportedFindingsByProperty: fromPromise(async ({
        input: { compliancePropertyId, serviceShortname },
    }: {
        input: {
            compliancePropertyId: number;
            serviceShortname: ServiceShortName | string;
        };
    }) => getPropertyReportedFindingsWizard(compliancePropertyId, serviceShortname)),
    submitReportedFindings: fromPromise(async ({
        input: {
            compliancePropertyId, problemRegisterId, documentIds, notes,
        },
    }: {
        input: {
            compliancePropertyId: number;
            problemRegisterId: number[];
            documentIds: string[];
            notes: string;
        };
    }) => {
        const response = await submitReportedFindingsDetails(
            compliancePropertyId,
            problemRegisterId,
            documentIds,
            notes
        );

        return response ?? null;
    }),
    requestQuoteReportedFindings: fromPromise(async ({
        input: {
            compliancePropertyId, problemRegisterIds,
        },
    }: {
        input: {
            compliancePropertyId: number;
            problemRegisterIds: number[];
        };
    }) => {
        const response = await requestQuoteReportedFindings(
            compliancePropertyId,
            problemRegisterIds
        );
        return response ?? null;
    }),
    informDIRequest: fromPromise(async ({
        input: {
            compliancePropertyId,
            problemRegisterIds,
            notes,
        },
    }: {
        input: {
            compliancePropertyId: number;
            problemRegisterIds: number[];
            notes?: string;
        };
    }) => {
        const response = await informDIRequest(
            compliancePropertyId,
            problemRegisterIds,
            notes ?? ''
        );
        return response ?? null;
    }),
    enterBuiltYearRequest: fromPromise(async ({
        input: {
            compliancePropertyId,
            problemRegisterIds,
            propertyBuilt,
            notes,
        },
    }: {
        input: {
            compliancePropertyId: number;
            problemRegisterIds: number[];
            propertyBuilt: Date;
            notes?: string;
        };
    }) => {
        const response = await resolveBuildYearRequest(
            compliancePropertyId,
            problemRegisterIds,
            propertyBuilt,
            notes
        );
        return response ?? null;
    }),
    dismissFindingRequest: fromPromise(async ({
        input: {
            problemRegisterId,
        },
    }: {
        input: {
            problemRegisterId: number | null;
        };
    }) => {
        if (problemRegisterId == null) { return null; }
        const res = await dismissReportedFinding(
            problemRegisterId
        );

        return res ?? null;
    }),
    unDismissFindingRequest: fromPromise(async ({
        input: {
            problemRegisterId,
        },
    }: {
        input: {
            problemRegisterId: number | null;
        };
    }) => {
        if (problemRegisterId == null) { return null; }
        const res = await unDismissReportedFinding(
            problemRegisterId
        );

        return res ?? null;
    }),
};
// TODO: Promise actors - submitting resolution
